module.exports = __webpack_public_path__ + "static/media/excel-recruitment.d2a79994.png";